import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { SiteDataProvider } from "./context/SiteDataContext";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <SiteDataProvider>
    <App />
  </SiteDataProvider>,
);
